/* eslint-disable camelcase */
import React, { useContext } from 'react'
import { ObjectivesFilterContext } from './parameters/filterContext'
import { useRiseUpClient } from '../hooks/useRiseUpClient'
import { Session } from './parameters'
import { useQuery } from 'react-query'
import { domoscioAccess } from '../api/domoscio_access'
import { Okn } from '../types/hub/objective'
import I18n from '../locales/I18n'
interface OknContext {
  isLoading: boolean
  isError: boolean
  isSuccess: boolean
  okns: Okn[]
}

const ObjectiveKnowledgeNodeContext = React.createContext<OknContext>({
  isLoading: false,
  isError: false,
  isSuccess: false,
  okns: []
})

type Props = {
  children: any
}
const ObjectiveKnowledgeNodeWrapper = ({ children }: Props) => {
  const { isRiseup } = useRiseUpClient()

  const objectiveFilters = useContext(ObjectivesFilterContext)
  const session = useContext(Session.State)

  const locale = I18n.locale

  const selectedObjectiveID = objectiveFilters.selectedObjective[0]?.id
  const objectivesOfExperience = objectiveFilters.objectiveFilters.objectivesOfSelectedExp || []

  let objectiveIds = [] as number[]

  if (isRiseup && session.options.analytics.objective_ids?.length > 0) {
    objectiveIds = session.options.analytics.objective_ids
  } else if (objectiveFilters.selectedObjective?.length > 0 && selectedObjectiveID !== 'all') {
    objectiveIds = objectiveFilters.selectedObjective.map(objective => Number(objective.id))
  } else if (selectedObjectiveID === 'all') {
    objectiveIds = objectivesOfExperience.map(objective => Number(objective.id))
  }
  const isEnabled = selectedObjectiveID !== 'no' && objectiveIds.length > 0

  // embed kn and objective for riseup, kn only for other clients
  const embed = isRiseup ? 'knowledge_node,objective' : 'knowledge_node'
  const result = useQuery(
    ['objectiveKnowledgeNodes', objectiveIds],
    async (): Promise<Okn[]> => {
      const okn = await domoscioAccess.getObjectiveKnowledgeNodes({
        objective_id: objectiveIds,
        lang: locale,
        embed
      })
      return okn
    },
    {
      enabled: isEnabled
    }
  )

  const contextValue = {
    isLoading: result.isLoading,
    isError: result.isError,
    isSuccess: result.isSuccess,
    okns: result.data || []
  }

  return (
    <ObjectiveKnowledgeNodeContext.Provider value={contextValue}>
      {children}
    </ObjectiveKnowledgeNodeContext.Provider>
  )
}

const useObjectiveKnowledgeNode = () => {
  const context = useContext(ObjectiveKnowledgeNodeContext)
  if (!context) {
    throw new Error('useObjectiveKnowledgeNode must be used within a ObjectiveKnowledgeNodeWrapper')
  }
  return context
}

export { ObjectiveKnowledgeNodeWrapper, ObjectiveKnowledgeNodeContext, useObjectiveKnowledgeNode }
